<template>
    <ListDeleteForm v-model="modelValue" v-bind="props" />
</template>
<script lang="ts" setup>
    import Modal from "@/components/Modal.vue";
    import ListDeleteForm from "@/components/ListDeleteForm.vue";
    import { SfButton } from "@storefront-ui/vue";
    import { ref, computed, inject } from "vue";
    import { router } from "@inertiajs/vue3";
    // import { route } from "ziggy-js";
    import { useLists } from "@/helpers/composables/useList";
    let route = inject('route');
    let { deleteList, deleteListRow } = useLists({ router, route });
    let modelValue = defineModel();
    let props = defineProps({
        type: {
            type: String,
            default: "list"
        },
        list_id: {
            type: Number,
            default: null
        },
        list_item_id: {
            type: Number,
            default: null
        },
        after_delete: {
            type: String
        },
        beforeCloseForItem: {
            type: Function,
            default: null
        },
        beforeCloseForList: {
            type: Function,
            default: null
        }
    });
</script>
